// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__5PBjR","left":"styles_left__2Rz2u","right":"styles_right__3-VWc","alert":"styles_alert__ydE8J"};